
import common from './common'
import { REPORT_PARAMS, PAGE_NUM, SDK_PRODUCT } from '@/config/dataMap'
import getClientInstallTime from '@/utils/getClientInstallTime'
const show_from = REPORT_PARAMS.show_from
const vip_version = REPORT_PARAMS.vip_version
const product_id = SDK_PRODUCT.id

// 支付模块二维码曝光监控
const qrcodeTechMonitorKfmt = 'duba_tech_monitor_qrcode:8462 version:byte product_id:int url:string action:byte qr_type:byte payid:int payid_time:int payway:byte user_login:byte vip_type:byte show_from:int scene:int qr_show:byte interface:string err_code:string days:int'

// pdf页面支付模块abtest上报
const pdfPagePaysetingABTest = 'duba_jipdf_vipabtest_show:7427 productid:int sence:string contentid:string showed:int noshowreason:string version:int'

// 前端性能上报
const performanceKfmt = 'duba_newvip_performance:7035 connect_end:int64 connect_start:int64 dom_complete:int64 dom_content_loaded_event_end:int64 dom_content_loaded_event_start:int64 dom_interactive:int64 dom_loading:int64 domain_lookup_end:int64 domain_lookup_start:int64 fetch_start:int64 load_event_end:int64 load_event_start:int64 navigation_start:int64 redirect_end:int64 redirect_start:int64 request_start:int64 response_end:int64 response_start:int64 secure_connection_start:int64 unload_event_end:int64 unload_event_start:int64 white_screen_time:int64 dns_time:int64 tcp_time:int64 load_time:int64 fullpage_load_time:int64 request_completed_time:int64 show_from:byte url:string product_id:byte'

/** PDF会员上报类型 */
const PDF_MEMBER_REPORT_TYPE = 11

/**
 * * 获取会员类型
 * * pdf会员（包含终身会员）上报类型：11
 * * 毒霸联合会员按照接口返回的vip_type
 * @returns {Number} 会员类型
 */
const getVipType = () => {
  const { userInfo, isPdfMember, isPdfLifeMember } = window.app.$store.getters
  const vipType = (userInfo && userInfo.vip_type) || 0

  if ((isPdfMember) || (isPdfLifeMember)) {
    return PDF_MEMBER_REPORT_TYPE
  }

  return vipType
}

/**
 *  * 获取timing
 *  * loadEventEnd为0，所以使用这种方式异步获取
 * @returns {Object} timing
 */
const getTiming = () => {
  return new Promise((resolve, reject) => {
    window.onload = () => {
      setTimeout(() => {
        resolve(performance.timing)
      }, 0)
    }
  })
}

export default {
  API: {
    method1 () {
    }
  },
  REPORT: {
    async fetmReportQrcode (params) {
      const vip_type = getVipType()
      const info = {
        qr_type: 0,
        payid: 0,
        payid_time: 0,
        payway: 0,
        qr_show: 0,
        user_login: window.app.$store.getters.loginStatus ? 1 : 2,
        vip_type,
        page_result: 1,
        version: 3,
        product_id,
        show_from,
        url: location.href || '',
        scene: params.scene || PAGE_NUM[window.app.$route.name] || 0,
        action: 0,
        interface: '',
        err_code: '',
        days: 0
      }
      try {
        const { install_days } = await getClientInstallTime()
        info.days = install_days
      } catch (err) {
        console.log('get install day err ', err)
      }
      return common.REPORT.client_report_by_kfmt(qrcodeTechMonitorKfmt, common.API.replaceObj(info, params))
    },
    reportPdfPagePaysetingABTest (params) {
      const info = {
        productid: product_id,
        sence: 0,
        contentid: 0, // 1展示了abtest的套餐 2展示原有的套餐
        showed: 0, // 1页面展示
        noshowreason: '', // 没有展示原因
        version: vip_version
      }
      return common.REPORT.client_report_by_kfmt(pdfPagePaysetingABTest, common.API.replaceObj(info, params))
    },

    async fetmReportPerformance (params = {}) {
      const {
        connectEnd, connectStart, domComplete,
        domContentLoadedEventEnd, domContentLoadedEventStart, domInteractive,
        domLoading, domainLookupEnd, domainLookupStart, fetchStart,
        loadEventEnd, loadEventStart, navigationStart, redirectEnd, redirectStart, requestStart,
        responseEnd, responseStart, secureConnectionStart, unloadEventEnd, unloadEventStart,
      } = await getTiming()

      const info = {
        connect_end: connectEnd, // 浏览器向服务器请求文档，建立连接成功的时间
        connect_start: connectStart, // 开始请求文档的时间（注意没有requestEnd）
        dom_complete: domComplete, // 浏览器把document.readyState设置为“complete”的时间点
        dom_content_loaded_event_end: domContentLoadedEventEnd, // 文档的DOMContentLoaded事件结束的时间 //文档的DOMContentLoaded事件结束的时间
        dom_content_loaded_event_start: domContentLoadedEventStart, // 文档发生DOMContentLoaded事件的时间
        dom_interactive: domInteractive, // 浏览器把document.readyState设置为“interactive”的时间点，DOM树创建结束
        dom_loading: domLoading, // 浏览器把document.readyState设置为“loading”的时间点，开始构建dom树的时间点
        domain_lookup_end: domainLookupEnd, // 返回浏览器结束DNS查询的时间，如果没有DNS查询过程
        domain_lookup_start: domainLookupStart, // 返回浏览器开始DNS查询的时间，如果此请求没有DNS查询过程，如长连接、资源cache、甚至是本地资源等，那么就返回fetchStart的值
        fetch_start: fetchStart, // 发起获取当前文档的时间点，我的理解是浏览器收到发起页面请求的时间点
        load_event_end: loadEventEnd, // 文档出发load事件结束后的时间
        load_event_start: loadEventStart, // 文档触发load事件的时间
        navigation_start: navigationStart, // 从同一个浏览器上下文的上一个文档卸载(unload)结束时的UNIX时间戳。如果没有上一个文档，这个值会和PerformanceTiming.fetchStart相同
        redirect_end: redirectEnd, // 重定向结束时间
        redirect_start: redirectStart, // 重定向开始时间
        request_start: requestStart, // 开始请求文档的时间（注意没有requestEnd）
        response_end: responseEnd, // 浏览器接收最后一个字节数据的时间，或连接被关闭的时间
        response_start: responseStart, // 浏览器开始接收第一个字节数据的时间，数据可能来自于服务器、缓存、或本地资源
        secure_connection_start: secureConnectionStart, // 返回浏览器与服务器开始安全链接的握手时的Unix毫秒时间戳。如果当前网页不要求安全连接，则返回0
        unload_event_end: unloadEventEnd, // 卸载上一个文档结束的时间
        unload_event_start: unloadEventStart, // 卸载上一个文档开始的时间
        white_screen_time: responseStart - navigationStart, // 白屏时间
        dns_time: domainLookupEnd - domainLookupStart, // 解析时间：domainLookupEnd -domainLookupStart
        tcp_time: connectEnd - connectStart, // TCP连接时间：connectEnd - connectStart
        load_time: loadEventEnd - loadEventStart, // onload阶段，load时间响应时间 loadEventEnd - loadEventStart
        fullpage_load_time: loadEventEnd - navigationStart, // 整个页面加载时间：loadEventEnd -navigationStart
        request_completed_time: domInteractive - responseEnd, // 请求完毕到DOM树加载domInteractive -responseEnd
        show_from: show_from, // 来源
        url: location.href || '', // 页面url
        product_id // 产品id
      }
      return common.REPORT.client_report_by_kfmt(performanceKfmt, common.API.replaceObj(info, params))
    }
  }
}
